const messages = {
  title: "Bonusa reizinātājs",
  bandBonusTitle: "Bonuss par riepu ar reizinātāju",
  amountLabel: "Min. riepu skaits (*)",
  label: "Bonusa reizinātājs",
  desc: "Bridgestone un Firestone riepu skaits. Par Firestone riepām nav bonusa eiro.",
  goals: {
    loyal: "Lojāls",
    bronze: "Bronza",
    silver: "Sudrabs",
    gold: "Zelts",
    platinum: "Platīns",
  },
  andMore: "un vairāk",
  chooseTarget: "Izvēlēties",
  selectTarget: "Izvēlieties savu gada mērķi {year} gadam:",
  multiplication: "Bonuss tiek reizināts ar <b>{factor}</b>",
  minTyres: "<b>Minimums:</b> {tyre} riepas",
};

export default {
  messages,
};
